<div class="col-sm-9 col-md-8">
  <div class="card pl-3 pr-3 pt-3 pb-3">
    <form
      [formGroup]="changePasswordForm"
      autocomplete="off"
      class="col-sm-12 col-md-8"
      role="form"
      aria-label="registration form"
    >
      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.CURRENT_PASSWORD_LBL' | translate }}</label
        >
        <input
          type="password"
          class="form-control"
          formControlName="current_password"
          role="textbox"
          aria-label="first name input field"
        />
        <div
          *ngIf="submitted && form.current_password.errors"
          class="invalid-feedback"
        >
          <div *ngIf="form.current_password.errors.required" role="alert">
            {{ 'ACCOUNT.CURRENT_PASSWORD_REQURIED' | translate }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.NEW_PASSWORD_LBL' | translate }}</label
        >
        <input
          type="password"
          class="form-control"
          formControlName="new_password"
          role="textbox"
          aria-label="first name input field"
        />
        <div
          *ngIf="submitted && form.new_password.errors"
          class="invalid-feedback"
        >
          <div *ngIf="form.new_password.errors.required" role="alert">
            {{ 'ACCOUNT.NEW_PASSWORD_REQURIED' | translate }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.CONFIRM_PASSWORD_LBL' | translate }}</label
        >
        <input
          type="password"
          class="form-control"
          formControlName="confirm_new_password"
          role="textbox"
          aria-label="first name input field"
        />
        <div
          *ngIf="submitted && form.confirm_new_password.errors"
          class="invalid-feedback"
        >
          <div *ngIf="form.confirm_new_password.errors.required" role="alert">
            {{ 'ACCOUNT.CONFIRM_PASSWORD_REQURIED' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="row mt-4">
    <div class="col-sm-12">
      <button
        class="btn btn-primary float-right col-12 col-sm-6 col-md-3 col-lg-3"
        type="button"
        (click)="onSubmit()"
      >
        {{ 'COMMON.UPDATE' | translate }}
      </button>
    </div>
  </div>
</div>
